// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RfNj","top":"styles_top__2Rgmg"};